module.exports = __webpack_public_path__ + "static/media/group-orange.91687d0c.svg";